<template>
    <div class="signature-popup" style="background-color: #FFFFFF;">
        <img
            v-if="defaultSignature.length>0"
            style="height: 75px; max-width: 184px"
            :src="defaultSignature"
            alt="signature"
            class="signature"
        />
        <div v-else class="signature-box">
            Signature not available
        </div>
        <br/><br/>

        <a class="signature-btn" href="javascript:void(0)" @click="toggleModal">
            <i class="fa fa-pencil"></i> {{ defaultSignature ? 'Update signature' : 'Click here to sign' }}
        </a>

        <modal ref="modal" :heading="`Signature`" :times-button="false">
            <div style="height: 450px;">
                <tabs @tab-selected="onTabSelected">
                    <tab name="Type" class="p-4" override-href="type" :selected="true">
                        <div style="height: 320px">
                            <input type="text" v-model="typedSignature" @input="updateTypedSignature" />
                            <div class="signature-preview dancing-script-400"
                                :style="{ fontFamily: 'Dancing Script', fontSize: '2rem' }">
                                {{ typedSignature }}
                            </div>
                        </div>
                    </tab>
                    <tab name="Draw" class="p-4" override-href="draw" :selected="false">
                        <vue-signature :disabled="isSaving" ref="signature" :sigOption="option" :w="'732px'" :h="'320px'"></vue-signature>
                    </tab>
                    <tab name="Image" class="p-4" override-href="image" :selected="false">
                        <div style="height: 320px">
                            <input type="file" @change="onFileChange" />
                            <img v-if="selectedImage" :src="selectedImage" alt="Selected Image"
                                style="max-height: 300px; max-width: 100%;" />
                        </div>
                    </tab>
                </tabs>
            </div>
            <div class="grid-x grid-padding-x align-right footer">
                <div class="cell shrink">
                    <button :disabled="isSaving" class="button success" type="button" @click="confirm"> {{ isSaving ? 'Uploading...' : 'Upload' }}</button>
                    <button type="submit" class="d-none" ref="submit"></button>
                </div>
                <div class="cell shrink">
                    <button class="button warning" type="button" @click="toggleModal">Cancel</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import Modal from './Modal.vue'
import VueSignature from "vue-signature";
import Tabs from './Tabs.vue'
import Tab from './Tab.vue'
import axios from 'axios';

export default {
    components: {
        Modal,
        VueSignature,
        Tabs,
        Tab
    },

    props: {
        text: {
            type: String,
            default: 'Create a signature'
        },
        defaultSignature: {
            type: String,
            default: ''
        },
        ifactFormId: {
            type: Number,
            default: null
        }
    },

    data() {
        return {
            option: {
                penColor: "rgb(0, 0, 0)",
                backgroundColor: "rgb(255,255,255)",
            },
            dataUrl: "",
            isSaving: false,
            typedSignature: '',
            selectedImage: null,
            selectedSignatureType: 'type', // to track the selected signature type
        };
    },

    methods: {
        toggleModal() {
            this.$refs.modal.toggle();
        },
        confirm() {
            this.uploadSignature();
        },
        onTabSelected(selectedTab) {
            this.selectedSignatureType = selectedTab.name.toLowerCase();
        },
        async dataURLToBlob(dataURL) {
            const byteString = atob(dataURL.split(',')[1]);
            const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
            const ab = new ArrayBuffer(byteString.length);
            const ia = new Uint8Array(ab);
            for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
            }
            const blob = new Blob([ab], { type: mimeString });
            return blob;
        },
        async uploadSignature() {
            let signatureData;

            switch (this.selectedSignatureType) {
                case 'type':
                    signatureData = this.createImageFromText(this.typedSignature);
                    break;
                case 'draw':
                    signatureData = this.$refs.signature.save();
                    break;
                case 'image':
                    signatureData = this.selectedImage;
                    break;
            }

            // Convert data URL to Blob
            const blob = await this.dataURLToBlob(signatureData);
            const formData = new FormData();
            formData.append('candidate_signature', blob, 'signature.png');
            formData.append('id', this.ifactFormId);

            try {
                this.isSaving = true;
                const response = await axios.post('/ajax/update-signature.json', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                if (response.data.success) {
                    this.defaultSignature = response.data.data.candidate_signature_cdn;
                    this.toggleModal();
                }

            } catch (error) {
                console.error('Error uploading signature:', error);
            }

            this.isSaving = false;
        },
        updateTypedSignature(event) {
            this.typedSignature = event.target.value;
        },
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.selectedImage = e.target.result;
                };
                reader.readAsDataURL(file);
            }
        },
        createImageFromText(text) {
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            const fontSize = 32; // Example font size, you can adjust as needed
            const fontFamily = 'Dancing Script';

            // Set font properties
            ctx.font = `${fontSize}px ${fontFamily}`;
            const textWidth = ctx.measureText(text).width;

            // Adjust canvas size based on text dimensions
            canvas.width = textWidth + 20; // Add some padding
            canvas.height = fontSize + 20; // Add some padding

            // Set font again after resizing canvas
            ctx.font = `${fontSize}px ${fontFamily}`;
            ctx.fillStyle = 'black';
            ctx.textBaseline = 'top';

            // Draw text on canvas
            ctx.fillText(text, 10, 10);

            // Convert canvas to data URL
            return canvas.toDataURL();
        },
        save() {
            var _this = this;
            var jpeg = _this.$refs.signature.save("image/jpeg");
            var svg = _this.$refs.signature.save("image/svg+xml");
            console.log(png);
            console.log(jpeg);
            console.log(svg);
        },
        clear() {
            var _this = this;
            _this.$refs.signature.clear();
        },
        undo() {
            var _this = this;
            _this.$refs.signature.undo();
        },
        addWaterMark() {
            var _this = this;
            _this.$refs.signature.addWaterMark({
                text: "mark text", // watermark text, > default ''
                font: "20px Arial", // mark font, > default '20px sans-serif'
                style: "all", // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
                fillStyle: "red", // fillcolor, > default '#333'
                strokeStyle: "blue", // strokecolor, > default '#333'
                x: 100, // fill positionX, > default 20
                y: 200, // fill positionY, > default 20
                sx: 100, // stroke positionX, > default 40
                sy: 200, // stroke positionY, > default 40
            });
        },
        fromDataURL(url) {
            var _this = this;
            _this.$refs.signature.fromDataURL(url);
        },
        handleDisabled() {
            var _this = this;
            _this.disabled = !_this.disabled;
        },
    }
}
</script>

<style scoped>
.signature-preview {
    margin-top: 10px;
    border: 1px solid #ccc;
    padding: 10px;
    font-size: 24px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000000;
}

.pointer-cursor {
    cursor: pointer;
}
</style>